var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bjBox"},[_c('img',{staticClass:"bj",attrs:{"src":_vm.bjData.imgUrl,"alt":""}}),_c('div',{staticClass:"titleBox"},[_c('div',[_vm._v(_vm._s(_vm.bjData.title))]),_c('div',[_vm._v(_vm._s(_vm.bjData.minTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }